import axios from "axios";
import Vue from "vue";
import URL from "../config/index";
import { Message } from "element-ui";
import allTits from "../assets/lan/tits.js";
import router from "../router.js";
import store from "../store";
import { BIZ_TOKEN, BIZ_USERINFO, BIZ_LANGUAGE_MAP } from "@/common/constant";
import { clearShopAuthStorage } from "@/util/shopAuth";

const axiosInstance = axios.create({
  baseURL: URL.BASE_URL,
  timeout: 15000,
  // headers: {'X-Custom-Header': 'foobar'}
});
// axios.defaults.timeout = 15000;
// axios.defaults.baseURL = URL.BASE_URL;
const requestLangMap = {
  [BIZ_LANGUAGE_MAP.zhCN]: "cn",
  [BIZ_LANGUAGE_MAP.zhTW]: "tw",
  [BIZ_LANGUAGE_MAP.en]: "en",
  [BIZ_LANGUAGE_MAP.ja]: "ja",
  [BIZ_LANGUAGE_MAP.de]: "de",
  [BIZ_LANGUAGE_MAP.ms]: "ms",
  [BIZ_LANGUAGE_MAP.af]: "af",
  [BIZ_LANGUAGE_MAP.th]: "th",
  [BIZ_LANGUAGE_MAP.el]: "el",
  [BIZ_LANGUAGE_MAP.pt]: "pt",
  [BIZ_LANGUAGE_MAP.es]: "es",
  [BIZ_LANGUAGE_MAP.fr]: "fr",
  [BIZ_LANGUAGE_MAP.ru]: "ru",
  [BIZ_LANGUAGE_MAP.it]: "it",
  [BIZ_LANGUAGE_MAP.tr]: "tr",
  [BIZ_LANGUAGE_MAP.ko]: "ko",
  [BIZ_LANGUAGE_MAP.ph]: "ph",
  [BIZ_LANGUAGE_MAP.ar]: "ar",
  [BIZ_LANGUAGE_MAP.id]: "id",
  [BIZ_LANGUAGE_MAP.hi]: "hi",
  [BIZ_LANGUAGE_MAP.vi]: "vi",
};
export const getCurrentLang = () => {
  const lang = store.getters.currentLang;
  return { lang: requestLangMap[lang] };
};

const handlerPostParams = (url, data) => {
  if (Object.keys(data).length) {
    for (let i in data) {
      url += url.indexOf("?") < 0 ? `?${i}=${data[i]}` : `&${i}=${data[i]}`;
    }
  }
  return url;
};

function readMemberFromStorage() {
  const s = store.state.userInfo;
  if (s && s.id) {
    return { id: s.id, username: s.username || s.mobile || "" };
  }
  try {
    const raw = sessionStorage.getItem(BIZ_USERINFO) || localStorage.getItem(BIZ_USERINFO);
    if (!raw) return null;
    const u = JSON.parse(raw);
    if (u && u.id) {
      return { id: u.id, username: u.username || u.mobile || "" };
    }
  } catch (e) {
    /* ignore */
  }
  return null;
}

/**
 * 与网关 / SecurityUtils 对齐：Authorization(Bearer)、UserId、username；
 * 兼容仅 localStorage 有 token 而 Vuex headers 未恢复的场景。
 * 登录、刷新令牌等请求使用 Basic 或 isToken:false，不得用旧 Bearer 覆盖。
 */
function mergeShopAuthHeaders(config) {
  config.headers = config.headers || {};
  const urlPath = (config.url || "").split("?")[0];
  const existingAuth = config.headers.Authorization || config.headers.authorization;
  const existingLower = existingAuth ? String(existingAuth).trim().toLowerCase() : "";
  const isBasicAuth = existingLower.startsWith("basic");
  const isGuestAuthCall =
    urlPath.includes("/auth/oauth/token") ||
    urlPath.includes("/auth/phone/token/") ||
    urlPath.includes("/auth/phone/token/sms") ||
    urlPath.includes("/auth/phone/token/thirdparty") ||
    urlPath.includes("/shop/register/") ||
    urlPath.includes("/upms/shop/register/");
  const skipMemberBearer =
    isBasicAuth ||
    config.headers.isToken === false ||
    config.headers.istoken === false ||
    isGuestAuthCall;

  if (skipMemberBearer) {
    return null;
  }

  const tokenRaw = localStorage.getItem(BIZ_TOKEN) || sessionStorage.getItem(BIZ_TOKEN);
  const h = store.state.headers || {};
  const mem = readMemberFromStorage();
  // 已退出但 localStorage 仍残留 token 时，不再携带无效凭证（避免首页公开接口 401）
  if (tokenRaw && !mem && !(h.Authorization && String(h.Authorization).trim())) {
    clearShopAuthStorage(store);
    return null;
  }
  const token = tokenRaw;
  const auth = (h.Authorization && String(h.Authorization).trim()) || (token ? "Bearer " + token : "");
  if (auth) {
    config.headers["Authorization"] = auth;
  }
  if (h.UserId) {
    config.headers["UserId"] = h.UserId;
  } else if (mem && mem.id) {
    config.headers["UserId"] = mem.id;
  }
  if (h.username) {
    config.headers["username"] = h.username;
  } else if (mem && mem.username) {
    config.headers["username"] = mem.username;
  }
  return token;
}

//http request 拦截器
axiosInstance.interceptors.request.use(
  (config) => {
    const token = mergeShopAuthHeaders(config);
    // config.data = JSON.stringify(config.data);
    // config.headers = {
    //   'Content-Type':'application/x-www-form-urlencoded'
    // }

    const method = (config.method || "get").toString().toLowerCase();

    if (method === "get") {
      if (token) {
        config.params = config.params || {};
        config.params.token = token;
      }
    } else if (method === "post") {
      if (config.data.body) {
        config.url = handlerPostParams(config.url, { token, ...config.data.params });
        config.data = config.data.body;
      } else {
        token && (config.data.token = token);
        config.url = handlerPostParams(config.url, config.data);
        config.data = null;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// let msgsCache = {};

// axios.interceptors.response.use(
//   (response) => {


//     return response;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

//http response 拦截器
axiosInstance.interceptors.response.use(
  (response) => {

    console.log("response ------------------------------------------ res ",response);

    return response;
  },
  (error) => {
    console.log("response ------------------------------------------ error axiosInstance ",error);
    if (error.response && error.response.status === 401) {
      const token = localStorage.getItem(BIZ_TOKEN) || sessionStorage.getItem(BIZ_TOKEN);
      // #region agent log
      fetch('http://127.0.0.1:7740/ingest/a9351a5b-1e14-43d3-b4dd-3beb0ed6fb3c',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'6c2a0d'},body:JSON.stringify({sessionId:'6c2a0d',runId:'pc-401',hypothesisId:'H2',location:'http.js:axiosInstance.401',message:'401 response',data:{url:(error.config&&error.config.url)||'',hadToken:!!token},timestamp:Date.now()})}).catch(()=>{});
      // #endregion
      if (token) {
        clearShopAuthStorage(store);
      } else {
        router.push('/login');
      }
    }
    return Promise.reject(error);
  }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function fetch(url, params = {}) {
  params = { ...params, ...getCurrentLang() };
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url, {
        params: params,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params = {}) {
  params = { ...params, ...getCurrentLang() };
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url, {
        params: params,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 封装get同步方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function getSync(url, data = {}) {
  data = { ...data, ...getCurrentLang() };
  return new Promise((resolve, reject) => {
    axiosInstance.get(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  data = { ...data, ...getCurrentLang() };
  return new Promise((resolve, reject) => {
    axiosInstance
    .post(url, {
      data: data,
      }).then((response) => {
        resolve(response.data);
      }).catch((err) => {
        reject(err);
      });


  //     axiosInstance
  //     .get(url, {
  //       params: params,
  //     })
  //     .then((response) => {
  //       resolve(response.data);
  //     })
  //     .catch((err) => {
  //       reject(err);
  //     });
  // });




  });
}

/**
 * 封装post同步请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function postSync(url, data = {}) {
  data = { ...data, ...getCurrentLang() };
  return new Promise((resolve, reject) => {
    axiosInstance.post(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

export function postBody(url, data = {}) {
  data = { params: getCurrentLang(), body: data };
  return new Promise((resolve, reject) => {
    axiosInstance.post(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  data = { ...data, ...getCurrentLang() };
  return new Promise((resolve, reject) => {
    axiosInstance.patch(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  data = { ...data, ...getCurrentLang() };
  return new Promise((resolve, reject) => {
    axiosInstance.put(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
// export default { fetch,get, patch, put,get, post, postBody };



axios.interceptors.request.use(config => {

  console.log("request ------------------------------------------ config ",config);

  const method = (config.method || "get").toString().toLowerCase();
  const token = mergeShopAuthHeaders(config);
  if (token) {
    if (method === "get") {
      config.params = config.params || {};
      config.params.token = token;
    } else if (method === "post" || method === "put") {
      config.data = config.data || {};
      config.data.token = token;
    }
  }

  // headers中配置serialize为true开启序列化
  if (method === "post" && config.headers.serialize) {
    config.data = serialize(config.data)
    // config.headers=['Content-Type'] = 'application/x-www-form-urlencoded';
    delete config.data.serialize
  }

  if (method === "get" && config.params) {
    let url = config.url;
    let hasQuery = url.indexOf('?') >= 0;
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof (value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            url += (hasQuery ? '&' : '?') + subPart + encodeURIComponent(value[key]);
            hasQuery = true;
          }
        } else {
          url += (hasQuery ? '&' : '?') + part + encodeURIComponent(value);
          hasQuery = true;
        }
      }
    }
    config.params = {};
    config.url = url;
  }



  return config
}, error => {
  return Promise.reject(error)
})

// HTTPresponse拦截
axios.interceptors.response.use(res => {
  console.log("response ------------------------------------------ res ",res);

  // NProgress.done()
  const status = Number(res.status) || 200
  const message = res.data.message;
  // const i18nMessageJsons= JSON.parse(sessionStorage.getItem("messages"));


  //非正常返回
  if (status !== 200 || res.data.code === 1) {

    console.log("response status",status);
    console.log("response message",message);
    console.log("response ------------------------------------------ res ",res);
    console.log("response code",res.data.code);

    // if (status === 400) {
    //   ElMessageBox({
    //     message: i18nMessageJsons[message] || i18nMessageJsons['common_message_badRequest'],
    //     type: 'error'
    //   })
    //   return Promise.reject(new Error(i18nMessageJsons['common_message_badRequest']));
    // }
    // //登录异常
    if (status === 401) {
      console.log("response ------------------------------------------ error 401 messages",JSON.parse(error.request.response));
      ElMessageBox({
        message: i18nMessageJsons[message] || i18nMessageJsons['common_message_unauthorized'],
        type: 'error'
      }).then(() => {
        store.dispatch('LogOut').then(() => {
          // 刷新登录页面，避免多次弹框
          window.location.reload();
        })
        // window.location.reload();
      })
      return Promise.reject(new Error(i18nMessageJsons['common_message_unauthorized']));
    }
    // //请求被拒绝
    // if (status === 403) {
    //   ElMessageBox({
    //     message: i18nMessageJsons[message] || i18nMessageJsons['common_message_forbidden'],
    //     type: 'error'
    //   })
    //   return Promise.reject(new Error(i18nMessageJsons['common_message_forbidden']));
    // }
    // //请求后台资源不存在
    // if (status === 404) {
    //   ElMessageBox({
    //     message: i18nMessageJsons[message] || i18nMessageJsons['common_message_notFound'],
    //     type: 'error'
    //   })
    //   return Promise.reject(new Error(i18nMessageJsons['common_message_notFound']));
    // }
    // //请求数据异常
    // if (status === 422) {
    //   ElMessageBox({
    //     message: i18nMessageJsons[message] || i18nMessageJsons['common_message_unprocessableEntity'],
    //     type: 'error'
    //   })
    //   return Promise.reject(new Error(i18nMessageJsons['common_message_unprocessableEntity']));
    // }
    // //登录令牌过期
    // if (status === 424) {
    //   ElMessageBox.confirm(i18nMessageJsons[message] || i18nMessageJsons['common_message_timeoutAuthorized'], i18nMessageJsons['common_syshint'], {
    //     confirmButtonText: i18nMessageJsons['common_ok'],
    //     cancelButtonText: i18nMessageJsons['common_cancel'],
    //     type: 'warning'
    //   }).then(() => {
    //     store.dispatch('LogOut').then(() => {
    //       // 刷新登录页面，避免多次弹框
    //       window.location.reload()
    //     })
    //     // window.location.reload();
    //   }).catch(() => {})
    //   return
    // }
    // //后台服务异常、未启动、链接错误
    // if (status === 503) {
    //   ElMessageBox({
    //     message: i18nMessageJsons[message] ||i18nMessageJsons['common_message_serviceUnavailable'],
    //     type: 'error'
    //   })
    //   return Promise.reject(new Error(i18nMessageJsons['common_message_serviceUnavailable']));
    // }
    // //后台内部错误
    // if (status === 500) {
    //   ElMessageBox({
    //     message: i18nMessageJsons[message] ||i18nMessageJsons['common_message_internalServerError'],
    //     type: 'error'
    //   })
    //   return Promise.reject(new Error(i18nMessageJsons['common_message_internalServerError']));
    // }
    // ElMessageBox({
    //   message: i18nMessageJsons[message],
    //   type: 'error'
    // })
    return Promise.reject(new Error(message))
  }
  return res
}, error => {

  console.log("response ------------------------------------------ error axios error",error.response);
  // console.log("response ------------------------------------------ error axios error.request",JSON.parse(error.request.response));
  // console.log("response ------------------------------------------ error axios messages",JSON.parse(error.request.response));
  if (!error.response) return Promise.reject(error);

  const status = Number(error.response.status)
  const responseJson = JSON.parse(error.request.response?error.request.response:'');
  const message =responseJson.message;

  if (status === 400) {


  }
  // //登录异常
  if (status === 401) {
    const token = localStorage.getItem(BIZ_TOKEN) || sessionStorage.getItem(BIZ_TOKEN);
    // #region agent log
    fetch('http://127.0.0.1:7740/ingest/a9351a5b-1e14-43d3-b4dd-3beb0ed6fb3c',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'6c2a0d'},body:JSON.stringify({sessionId:'6c2a0d',runId:'pc-401',hypothesisId:'H2',location:'http.js:axios.401',message:'401 response',data:{url:(error.config&&error.config.url)||'',hadToken:!!token},timestamp:Date.now()})}).catch(()=>{});
    // #endregion
    if (token) {
      clearShopAuthStorage(store);
    } else {
      router.push('/login');
    }
  }
  //请求被拒绝
  if (status === 403) {

  }
  //请求后台资源不存在
  if (status === 404) {

  }
  //请求数据异常
  if (status === 422) {

  }
  //登录令牌过期
  if (status === 424) {

    //清tocken
    // store.dispatch('LogOut').then(() => {
      // 刷新登录页面，避免多次弹框
    // window.location.reload();
    
  }
  //后台服务异常、未启动、链接错误
  if (status === 503) {


  }
  //后台内部错误
  if (status === 500) {

    
  }
  //   message: "System failure. Please contact service provider",
  //   type: 'error'

  return Promise.reject(error)
})

// 通用下载方法
export function download(url, params, filename) {
  return axios.post(url, params, {
    transformRequest: [(params) => {
      return tansParams(params)
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    responseType: 'blob'
  }).then((data) => {
    const content = data
    const blob = new Blob([content])
    if ('download' in document.createElement('a')) {
      const elink = document.createElement('a')
      elink.download = filename
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    } else {
      navigator.msSaveBlob(blob, filename)
    }
  }).catch((r) => {
    console.error(r)
  })
}
export default axios
export { axiosInstance }


